import { Button } from 'antd';

import { Icon } from '@/components/Icon';
import { useIsMobile } from '@/hooks';

type Props = {
  currentSlide: number;
  planificationDatesLength: number;
  handleNext: () => void;
};

const MOBILE_SLIDES = 3;
const DEFAULT_SLIDES = 7;

export const NextButton: React.FC<Props> = ({
  currentSlide,
  planificationDatesLength,
  handleNext
}) => {
  const isMobile = useIsMobile('md');
  const slidesPerGroup = isMobile ? MOBILE_SLIDES : DEFAULT_SLIDES;
  const maxSlideIndex = Math.max(0, planificationDatesLength - slidesPerGroup);

  return (
    <Button
      type="text"
      icon={<Icon i="ChevronRight" />}
      onClick={handleNext}
      disabled={currentSlide >= maxSlideIndex}
    />
  );
};
